export default {
    whoTitle: "من نحن",
    whoPart: `
    تطبيق ADtv هو منصة الفيديو حسب الطلب من أبوظبي للإعلام، والذي يوفّر ترفيهاً حصرياً وعالي الجودة مجانًا للمشاهدين العرب، بما في ذلك المحتوى الجديد والمتميز من Nat Geo. يتضمن تطبيق ADtv مجموعة متكاملة من الخدمات الرقمية، بما في ذلك البث المباشر لشبكة قنوات تلفزيون أبوظبي.
    `,
};